import React, { useState } from 'react';
import spk1 from '../../assets/images/team/team-1-1.jpg';
import spk2 from '../../assets/images/team/team-1-2.jpg';
import spk3 from '../../assets/images/team/team-1-3.jpg';
import spk4 from '../../assets/images/team/team-1-4.jpg';
import spk5 from '../../assets/images/team/team-1-5.jpg';
import spk6 from '../../assets/images/team/team-1-6.jpg';
import spk7 from '../../assets/images/team/team-2-1.jpg';
import spk8 from '../../assets/images/team/team-2-2.jpg';
import spk9 from '../../assets/images/team/team-2-3.jpg';

const IMG_MAP = {
    'team-1-1.jpg': spk1,
    'team-1-2.jpg': spk2,
    'team-1-3.jpg': spk3,
    'team-1-4.jpg': spk4,
    'team-1-5.jpg': spk5,
    'team-1-6.jpg': spk6,
    'team-2-1.jpg': spk7,
    'team-2-2.jpg': spk8,
    'team-2-3.jpg': spk9,
};

const trackColors = {
    'Offensive':    '#ff4d4d',
    'Defensive':    '#4d9fff',
    'CTF':          '#ffd700',
    'Cloud & AppSec':'#4dffb4',
    'AI / ML':      '#b44dff',
    'Training':     '#ff9f4d',
};

export default function SpeakersGrid({ speakers: rawSpeakers, pageContent, tracks }) {
    const [activeTrack, setActiveTrack] = useState('All');
    const [modal, setModal] = useState(null);

    const speakers = (rawSpeakers || []).map(s => ({
        ...s,
        resolvedImg: IMG_MAP[s.img] || s.img,
    }));

    const filtered = activeTrack === 'All'
        ? speakers
        : speakers.filter(s => s.track === activeTrack);

    return (
        <section className="spk-grid-section">
            <style>{`
                .spk-grid-section {
                    background: var(--eventflow-black);
                    padding: 80px 0 100px;
                    position: relative;
                    overflow: hidden;
                }
                .spk-grid-section::before {
                    content: '';
                    position: absolute; inset: 0;
                    background: radial-gradient(ellipse at 70% 30%, rgba(var(--eventflow-primary-rgb),0.08) 0%, transparent 55%);
                    pointer-events: none;
                }

                /* filter tabs */
                .spk-filters {
                    display: flex; flex-wrap: wrap;
                    gap: 8px; justify-content: center;
                    margin-bottom: 56px;
                }
                .spk-filter {
                    font-family: var(--eventflow-font);
                    font-size: 13px; font-weight: 600;
                    padding: 8px 20px; border-radius: 50px;
                    border: 1px solid rgba(255,255,255,0.1);
                    background: transparent;
                    color: rgba(255,255,255,0.45);
                    cursor: pointer; transition: all 0.25s;
                }
                .spk-filter:hover {
                    border-color: rgba(var(--eventflow-base-rgb),0.4);
                    color: #fff;
                }
                .spk-filter--active {
                    background: var(--eventflow-base);
                    border-color: var(--eventflow-base);
                    color: #fff;
                }

                /* keynote badge */
                .spk-keynote-label {
                    font-family: var(--eventflow-font);
                    font-size: 11px; font-weight: 700;
                    letter-spacing: 3px; text-transform: uppercase;
                    color: rgba(255,255,255,0.25);
                    margin-bottom: 20px;
                    display: flex; align-items: center; gap: 10px;
                }
                .spk-keynote-label::after {
                    content: ''; flex: 1; height: 1px;
                    background: rgba(255,255,255,0.06);
                }

                /* grid */
                .spk-grid {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 20px;
                    margin-bottom: 30px;
                }
                .spk-grid--keynote {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: flex-start;
                    gap: 24px;
                    margin-bottom: 40px;
                }
                .spk-grid--keynote > * {
                    flex: 0 0 calc(33.333% - 16px);
                    max-width: 340px;
                }

                /* card */
                .spk-card {
                    background: rgba(255,255,255,0.03);
                    border: 1px solid rgba(255,255,255,0.07);
                    border-radius: 16px;
                    overflow: hidden;
                    cursor: pointer;
                    transition: all 0.3s;
                    position: relative;
                }
                .spk-card::before {
                    content: '';
                    position: absolute; top: 0; left: 0; right: 0; height: 2px;
                    opacity: 0; transition: opacity 0.3s;
                }
                .spk-card:hover {
                    border-color: rgba(var(--eventflow-base-rgb),0.3);
                    transform: translateY(-5px);
                    box-shadow: 0 20px 50px rgba(0,0,0,0.4);
                }
                .spk-card:hover::before { opacity: 1; }

                .spk-card__img-wrap {
                    position: relative;
                    aspect-ratio: 410 / 455;
                    overflow: hidden;
                }
                .spk-card__img-wrap img {
                    width: 100%; height: 100%; object-fit: cover;
                    filter: brightness(0.82) saturate(0.85);
                    transition: filter 0.4s, transform 0.4s;
                }
                .spk-card:hover .spk-card__img-wrap img {
                    filter: brightness(0.92) saturate(1.0);
                    transform: scale(1.05);
                }
                .spk-card__img-overlay {
                    position: absolute; inset: 0;
                    background: linear-gradient(to top, rgba(4,0,10,0.85) 0%, transparent 55%);
                }
                .spk-card__keynote-badge {
                    position: absolute; top: 14px; left: 14px;
                    background: var(--eventflow-base);
                    color: #fff; font-family: var(--eventflow-font);
                    font-size: 10px; font-weight: 700;
                    letter-spacing: 1.5px; text-transform: uppercase;
                    padding: 4px 12px; border-radius: 20px;
                    box-shadow: 0 4px 12px rgba(var(--eventflow-base-rgb),0.4);
                }
                .spk-card__track {
                    position: absolute; top: 14px; right: 14px;
                    font-family: 'Courier New', monospace;
                    font-size: 10px; font-weight: 700;
                    padding: 4px 10px; border-radius: 6px;
                    letter-spacing: 0.5px;
                }
                .spk-card__socials {
                    position: absolute; bottom: 14px; right: 14px;
                    display: flex; gap: 6px;
                    opacity: 0; transform: translateY(6px);
                    transition: all 0.3s;
                }
                .spk-card:hover .spk-card__socials {
                    opacity: 1; transform: translateY(0);
                }
                .spk-card__social {
                    width: 28px; height: 28px; border-radius: 6px;
                    background: rgba(4,0,10,0.7);
                    border: 1px solid rgba(255,255,255,0.1);
                    display: flex; align-items: center; justify-content: center;
                    color: rgba(255,255,255,0.7); font-size: 12px;
                    text-decoration: none; transition: all 0.2s;
                }
                .spk-card__social:hover {
                    background: var(--eventflow-base); color: #fff;
                    border-color: var(--eventflow-base);
                }

                .spk-card__body { padding: 18px 20px 20px; }
                .spk-card__name {
                    font-family: var(--eventflow-font);
                    font-size: 17px; font-weight: 800;
                    color: #fff; margin-bottom: 4px;
                }
                .spk-card__role {
                    font-family: var(--eventflow-font);
                    font-size: 12px; color: rgba(255,255,255,0.4);
                    margin-bottom: 10px;
                }
                .spk-card__talk {
                    font-family: var(--eventflow-font);
                    font-size: 13px; font-weight: 600;
                    color: rgba(255,255,255,0.65);
                    line-height: 1.5;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
                .spk-card__more {
                    display: inline-flex; align-items: center; gap: 5px;
                    font-family: var(--eventflow-font);
                    font-size: 12px; font-weight: 600;
                    color: var(--eventflow-base);
                    margin-top: 10px;
                    opacity: 0; transition: opacity 0.3s;
                }
                .spk-card:hover .spk-card__more { opacity: 1; }

                /* modal */
                .spk-modal-bg {
                    position: fixed; inset: 0;
                    background: rgba(0,0,0,0.85);
                    z-index: 9999;
                    display: flex; align-items: center; justify-content: center;
                    padding: 20px;
                    backdrop-filter: blur(8px);
                    animation: spkFadeIn 0.2s ease;
                }
                @keyframes spkFadeIn { from{opacity:0} to{opacity:1} }
                .spk-modal {
                    background: #0d0010;
                    border: 1px solid rgba(255,255,255,0.1);
                    border-radius: 20px;
                    max-width: 640px; width: 100%;
                    overflow: hidden;
                    box-shadow: 0 40px 100px rgba(0,0,0,0.7);
                    animation: spkSlideUp 0.25s ease;
                }
                @keyframes spkSlideUp {
                    from { transform: translateY(20px); opacity: 0; }
                    to   { transform: translateY(0);    opacity: 1; }
                }
                .spk-modal__header {
                    display: flex; gap: 20px; padding: 28px 28px 20px;
                    border-bottom: 1px solid rgba(255,255,255,0.07);
                    position: relative;
                }
                .spk-modal__img {
                    width: 80px; height: 80px; border-radius: 12px;
                    object-fit: cover; flex-shrink: 0;
                    border: 2px solid rgba(var(--eventflow-base-rgb),0.3);
                }
                .spk-modal__info { flex: 1; }
                .spk-modal__name {
                    font-family: var(--eventflow-font);
                    font-size: 22px; font-weight: 800; color: #fff; margin-bottom: 4px;
                }
                .spk-modal__role {
                    font-family: var(--eventflow-font);
                    font-size: 13px; color: rgba(255,255,255,0.45); margin-bottom: 10px;
                }
                .spk-modal__track {
                    display: inline-block;
                    font-family: 'Courier New', monospace;
                    font-size: 10px; font-weight: 700;
                    padding: 3px 10px; border-radius: 6px;
                    letter-spacing: 0.5px;
                }
                .spk-modal__close {
                    position: absolute; top: 20px; right: 20px;
                    width: 32px; height: 32px; border-radius: 8px;
                    background: rgba(255,255,255,0.07);
                    border: 1px solid rgba(255,255,255,0.1);
                    display: flex; align-items: center; justify-content: center;
                    cursor: pointer; color: rgba(255,255,255,0.6);
                    font-size: 14px; transition: all 0.2s;
                }
                .spk-modal__close:hover {
                    background: rgba(var(--eventflow-base-rgb),0.2);
                    color: #fff;
                }
                .spk-modal__body { padding: 24px 28px 28px; }
                .spk-modal__talk-label {
                    font-family: var(--eventflow-font);
                    font-size: 10px; font-weight: 700;
                    letter-spacing: 2px; text-transform: uppercase;
                    color: var(--eventflow-base); margin-bottom: 8px;
                }
                .spk-modal__talk {
                    font-family: var(--eventflow-font);
                    font-size: 17px; font-weight: 800;
                    color: #fff; line-height: 1.4; margin-bottom: 16px;
                }
                .spk-modal__bio {
                    font-family: var(--eventflow-font);
                    font-size: 14px; color: rgba(255,255,255,0.5);
                    line-height: 1.75; margin-bottom: 20px;
                }
                .spk-modal__socials { display: flex; gap: 10px; }
                .spk-modal__social {
                    display: inline-flex; align-items: center; gap: 7px;
                    background: rgba(255,255,255,0.05);
                    border: 1px solid rgba(255,255,255,0.1);
                    border-radius: 8px; padding: 8px 14px;
                    font-family: var(--eventflow-font);
                    font-size: 13px; color: rgba(255,255,255,0.6);
                    text-decoration: none; transition: all 0.2s;
                }
                .spk-modal__social:hover {
                    background: rgba(var(--eventflow-base-rgb),0.1);
                    border-color: rgba(var(--eventflow-base-rgb),0.3);
                    color: #fff;
                }
                .spk-modal__social i { color: var(--eventflow-base); }

                /* CFP CTA */
                .spk-cfp-cta {
                    margin-top: 60px;
                    background: rgba(var(--eventflow-base-rgb),0.05);
                    border: 1px dashed rgba(var(--eventflow-base-rgb),0.2);
                    border-radius: 16px; padding: 36px 40px;
                    display: flex; align-items: center;
                    justify-content: space-between; gap: 20px;
                    flex-wrap: wrap;
                }
                .spk-cfp-cta__text h4 {
                    font-family: var(--eventflow-font);
                    font-size: 20px; font-weight: 800; color: #fff; margin-bottom: 6px;
                }
                .spk-cfp-cta__text p {
                    font-size: 13px; color: rgba(255,255,255,0.4); margin: 0;
                }

                @media (max-width: 1199px) {
                    .spk-grid { grid-template-columns: repeat(3,1fr); }
                    .spk-grid--keynote > * { flex: 0 0 calc(50% - 12px); max-width: 400px; }
                }
                @media (max-width: 991px) {
                    .spk-grid { grid-template-columns: repeat(2,1fr); }
                }
                @media (max-width: 576px) {
                    .spk-grid { grid-template-columns: 1fr; }
                    .spk-grid--keynote > * { flex: 0 0 100%; max-width: 100%; }
                    .spk-cfp-cta { padding: 24px 20px; }
                    .spk-modal__header { flex-direction: column; }
                    .spk-modal__img { width: 64px; height: 64px; }
                }
            `}</style>

            <div className="container">
                {/* Filter tabs */}
                <div className="spk-filters wow fadeInUp" data-wow-delay="100ms">
                    {tracks.map((t, i) => (
                        <button
                            key={i}
                            className={`spk-filter${activeTrack === t ? ' spk-filter--active' : ''}`}
                            onClick={() => setActiveTrack(t)}
                        >
                            {t}
                        </button>
                    ))}
                </div>

                {/* Keynote speakers */}
                {(activeTrack === 'All' || filtered.some(s => s.keynote)) && (
                    <>
                        {activeTrack === 'All' && (
                            <div className="spk-keynote-label wow fadeInUp" data-wow-delay="100ms">
                                Keynote Speakers
                            </div>
                        )}
                        <div className="spk-grid spk-grid--keynote wow fadeInUp" data-wow-delay="150ms">
                            {(activeTrack === 'All' ? speakers.filter(s => s.keynote) : filtered.filter(s => s.keynote))
                                .map((s, i) => (
                                    <SpeakerCard key={i} speaker={s} onClick={() => setModal(s)} />
                                ))}
                        </div>
                    </>
                )}

                {/* All / other speakers */}
                {activeTrack === 'All' && (
                    <div className="spk-keynote-label wow fadeInUp" data-wow-delay="100ms">
                        All Speakers
                    </div>
                )}
                <div className="spk-grid wow fadeInUp" data-wow-delay="200ms">
                    {(activeTrack === 'All' ? speakers.filter(s => !s.keynote) : filtered.filter(s => !s.keynote))
                        .map((s, i) => (
                            <SpeakerCard key={i} speaker={s} onClick={() => setModal(s)} />
                        ))}
                </div>

                {/* CFP CTA */}
                <div className="spk-cfp-cta wow fadeInUp" data-wow-delay="200ms">
                    <div className="spk-cfp-cta__text">
                        <h4>{pageContent.cfpCta.title}</h4>
                        <p>{pageContent.cfpCta.description}</p>
                    </div>
                    <a href={pageContent.cfpCta.buttonLink} className="thm-btn">
                        {pageContent.cfpCta.buttonText} <span className="icon-arrow-right" />
                    </a>
                </div>
            </div>

            {/* Modal */}
            {modal && (
                <div className="spk-modal-bg" onClick={() => setModal(null)}>
                    <div className="spk-modal" onClick={e => e.stopPropagation()}>
                        <div className="spk-modal__header">
                            {modal.resolvedImg ? (
                                <img className="spk-modal__img" src={modal.resolvedImg} alt={modal.name} />
                            ) : (
                                <div className="spk-modal__img" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(var(--eventflow-base-rgb),0.1)', fontSize: '28px', color: 'var(--eventflow-base)' }}>
                                    <i className="fa fa-user" />
                                </div>
                            )}
                            <div className="spk-modal__info">
                                <div className="spk-modal__name">{modal.name}</div>
                                <div className="spk-modal__role">{modal.role} · {modal.org}</div>
                                <span
                                    className="spk-modal__track"
                                    style={{
                                        color: trackColors[modal.track] || '#fff',
                                        background: `${trackColors[modal.track] || '#fff'}18`,
                                        border: `1px solid ${trackColors[modal.track] || '#fff'}30`,
                                    }}
                                >
                                    {modal.track}
                                </span>
                            </div>
                            <button className="spk-modal__close" onClick={() => setModal(null)}>
                                <i className="fa fa-times" />
                            </button>
                        </div>
                        <div className="spk-modal__body">
                            <div className="spk-modal__talk-label">Talk</div>
                            <div className="spk-modal__talk">{modal.talk}</div>
                            <p className="spk-modal__bio">{modal.bio}</p>
                            <div className="spk-modal__socials">
                                {modal.twitter && (
                                    <a href={modal.twitter} className="spk-modal__social" target="_blank" rel="noopener noreferrer">
                                        <i className="fab fa-twitter" /> Twitter
                                    </a>
                                )}
                                {modal.linkedin && (
                                    <a href={modal.linkedin} className="spk-modal__social" target="_blank" rel="noopener noreferrer">
                                        <i className="fab fa-linkedin-in" /> LinkedIn
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}

function SpeakerCard({ speaker, onClick }) {
    const color = trackColors[speaker.track] || '#fff';
    return (
        <div
            className="spk-card"
            onClick={onClick}
            style={{ '--spk-track-color': color }}
        >
            <style>{`.spk-card:hover::before { background: linear-gradient(90deg, ${color}, var(--eventflow-primary)); }`}</style>
            <div className="spk-card__img-wrap">
                {speaker.resolvedImg ? (
                    <img src={speaker.resolvedImg} alt={speaker.name} />
                ) : (
                    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(var(--eventflow-base-rgb),0.05)' }}>
                        <i className="fa fa-user" style={{ fontSize: '64px', color: 'rgba(var(--eventflow-base-rgb), 0.5)' }} />
                    </div>
                )}
                <div className="spk-card__img-overlay" />
                {speaker.keynote && (
                    <span className="spk-card__keynote-badge">Keynote</span>
                )}
                <span
                    className="spk-card__track"
                    style={{
                        color,
                        background: `${color}18`,
                        border: `1px solid ${color}30`,
                    }}
                >
                    {speaker.track}
                </span>
                <div className="spk-card__socials">
                    {speaker.twitter && (
                        <a href={speaker.twitter} className="spk-card__social" onClick={e => e.stopPropagation()} target="_blank" rel="noopener noreferrer">
                            <i className="fab fa-twitter" />
                        </a>
                    )}
                    {speaker.linkedin && (
                        <a href={speaker.linkedin} className="spk-card__social" onClick={e => e.stopPropagation()} target="_blank" rel="noopener noreferrer">
                            <i className="fab fa-linkedin-in" />
                        </a>
                    )}
                </div>
            </div>
            <div className="spk-card__body">
                <div className="spk-card__name">{speaker.name}</div>
                <div className="spk-card__role">{speaker.role} · {speaker.org}</div>
                <div className="spk-card__talk">{speaker.talk}</div>
                <span className="spk-card__more">View Details <i className="fa fa-arrow-right" /></span>
            </div>
        </div>
    );
}
